export enum Languages {
  'Português' = `pt-BR`,
  'Inglês' = `en-US`,
  'Espanhol' = `es`,
}
